import { z } from "zod";
import { IGroupItem, IGroupRequest } from "../../../../../@types/group.type";
import { Controller, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Autocomplete from "@mui/material/Autocomplete";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import styles from "./styles.module.scss";
import closeIconModal from "./../../../../../assets/_CloseIconModal_.svg";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { getAllGroups } from "../../../../../services/api/groups/groupsService";

const selectGroupSchema = z.object({
    groupsNew: z
      .array(
        z.object({
          groupId: z.string(),
          groupName: z.string(),
        })
      )
      .min(1, "Selecione pelo menos um grupo"),
  });

interface SelectGroupModalProps {
    open: boolean;
    onClose: () => void;
    groups: IGroupRequest[]
    setGroups: React.Dispatch<
    React.SetStateAction<IGroupRequest[] | []>>;
}

export const SelectGroupModal: React.FC<SelectGroupModalProps> = ({
    open,
    onClose,
    groups,
    setGroups
  }) => {
    const {
      control,
      reset,
      formState: { errors },
      trigger,
    } = useForm({
        resolver: zodResolver(selectGroupSchema),
        defaultValues: {
            groupsNew: [] as IGroupRequest[]
        }
    });
    const [loading, setLoading] = useState<boolean>(false);
    const [availableGroups, setAvailableGroups] = useState<IGroupRequest[]>([]);
    const [selectedGroups, setSelectedGroups] = useState<IGroupRequest[]>([]);

    useEffect(() => {
        const fetchGroups = async () => {
          try {
            const response = await getAllGroups(); // Chama a API para obter os grupos
            if (response.statusCode === 200) {
              const filteredGroups = response.result
                .map((group: IGroupItem) => ({
                  groupId: group.id,
                  groupName: group.name,
                }))
                .filter(
                  (group: IGroupRequest) => !groups.some((existingGroup) => existingGroup.groupId === group.groupId)
                );
              setAvailableGroups(filteredGroups); // Atualiza os grupos disponíveis
            } else {
              toast.error("Erro ao carregar os grupos disponíveis. Tente novamente!");
            }
          } catch (error) {
            console.log(error)
            toast.error("Erro ao carregar os grupos disponíveis.");
          }
        };
    
        if (open) {
          fetchGroups();
        }
      }, [open, groups]);

    const handleClose = () => {
        reset();
        onClose();
      };

    const handleGroupChange = (newGroups: IGroupRequest[]) => {
        setSelectedGroups(newGroups);
    };

    const handleAddGroups = async () => {

        const isValid = await trigger("groupsNew");

        if (!isValid) {
        return;
        }

        setGroups((prevGroups) => {
            const newGroupsFiltered = selectedGroups.filter(
                (newGroup) => !prevGroups.some((group) => group.groupId === newGroup.groupId)
            );
            return [...prevGroups, ...newGroupsFiltered];
        });
        handleClose();
    };

    return(
        <>
        <Modal open={open} onClose={handleClose}>
            <Box className={styles.modalBox}>
                <div className={styles.modalTitle}>
                    <h3>Adicione Grupos de Permissões no Usuário</h3>
                    <Button onClick={handleClose} className={styles.iconButton}>
                    {closeIconModal && <img src={closeIconModal} />}
                    </Button>
                </div>

                <Controller
                    name="groupsNew"
                    control={control}
                    defaultValue={[]}
                    render={({ field }) => (
                    <Autocomplete
                        multiple
                        limitTags={3}
                        fullWidth
                        id="checkboxes-tags-demo"
                        options={availableGroups}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.groupName || ""}
                        isOptionEqualToValue={(option, value) =>
                        option.groupId === value.groupId
                        }
                        noOptionsText="Sem opções"
                        renderOption={(props, option, { selected }) => {
                        const { key, ...optionProps } = props;

                        return (
                            <li key={option.groupId} {...optionProps}>
                            <Checkbox
                                style={{ marginRight: 8 }}
                                checked={selected}
                            />
                            {option.groupName}
                            </li>
                        );
                        }}
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            label="Selecione"
                            placeholder="Busque os grupos..."
                            error={!!errors.groupsNew}
                            helperText={
                            errors.groupsNew ? errors.groupsNew.message : null
                            }
                            InputLabelProps={{
                                shrink: true,
                              }}
                        />
                        )}
                        onChange={(_, value) => {
                            field.onChange(value);
                            handleGroupChange(value);
                          }}
                        value={field.value}
                    />
                    )}
                />

                <Stack direction="row" spacing={2} className={styles.stackButton}>
                    <Button
                         variant="contained"
                         color="primary"
                         disabled={loading}
                         onClick={handleAddGroups}
                         className={styles.btnCreate}
                        >
                        Adicionar
                    </Button>
                </Stack>
            </Box>
        </Modal>
        </>
    )
}